import { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { api } from "../lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/password/forgot", { email });
      setSent(true);
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#050505] px-6 py-12">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="w-full max-w-md"
        data-testid="forgot-page"
      >
        <Link to="/" className="block text-center mb-12">
          <span className="font-display text-3xl tracking-tight text-gold">Wanted</span>
        </Link>
        <div className="glass-strong rounded-3xl p-10">
          <div className="text-gold-soft tracking-overline text-xs mb-3 text-center">FORGOT PASSWORD</div>
          <h1 className="font-display text-3xl font-light text-center mb-8 leading-tight">
            {sent ? "Check your inbox." : "Reset your password."}
          </h1>
          {sent ? (
            <p className="text-white/60 leading-relaxed text-center" data-testid="forgot-sent-msg">
              If we have an account with that email, we've sent you a reset link.
              It will expire in one hour.
            </p>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <input
                type="email" required placeholder="your@email.com"
                value={email} onChange={(e) => setEmail(e.target.value)}
                className="input-luxe" data-testid="forgot-email-input"
              />
              <button type="submit" disabled={loading} className="btn-gold w-full" data-testid="forgot-submit-btn">
                {loading ? "Sending..." : "Send reset link"}
              </button>
            </form>
          )}
          <p className="text-center text-sm text-white/50 mt-8">
            <Link to="/login" className="text-gold hover:text-gold-soft transition-colors" data-testid="back-to-login">
              ← Back to sign in
            </Link>
          </p>
        </div>
      </motion.div>
    </div>
  );
}
